/**
 * Spec 053 BR-31 — the single finance glossary.
 *
 * The source of truth is `services/merchant-settlement/src/main/resources/finance-glossary.json`
 * (the CSV exports open with it). `./finance-glossary.json` is a checked-in byte-identical copy;
 * `FinanceCsvExporterTest.glossary_frontendCopyIsByteIdentical` and `Money.test.tsx` fail when
 * the two drift. Edit the settlement resource, then copy it here.
 *
 * Every admin-facing financial figure renders through `<Money glossaryKey=… />`, which looks its
 * explanation up here and shows it in an `<InfoTip>`. A figure whose key is missing throws in
 * dev/test and fails `Money.test.tsx`, so this file is the contract: add the entry BEFORE the figure.
 *
 * Keep each entry answering three questions an admin actually asks:
 *   definition  — what is this number?
 *   computed    — how does the system arrive at it?
 *   whenWrong   — what does an unexpected value usually mean?
 */
import glossaryJson from './finance-glossary.json';

export interface GlossaryEntry {
  label: string;
  definition: string;
  computed: string;
  whenWrong: string;
}

export type GlossaryKey = keyof typeof glossaryJson;

export const FINANCE_GLOSSARY: Record<GlossaryKey, GlossaryEntry> = glossaryJson;

export function isGlossaryKey(key: string): key is GlossaryKey {
  return Object.prototype.hasOwnProperty.call(FINANCE_GLOSSARY, key);
}
